/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/ActionsAction/Content/EditAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 block={true}
 justifyContent="flex-start"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Edit/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../Edit/Content'))}
 stopPropagation={true}
 text="Edit charge"
/>
{children}
</React.Fragment>)
}